import OAuth from "../oauth";
import Services from "../services";
export default (function (_ref) {
  var app = _ref.app,
    router = _ref.router,
    Vue = _ref.Vue;
  var oauth = new OAuth();
  Vue.prototype.$oauth = oauth;
  Services.run({
    oauth: oauth
  });
});